import React from 'react';
import styled from 'styled-components';
import Layout from './Layout';
import Container from '../components/Container';
import Grid from '@material-ui/core/Grid';
import SGHeadline from '../components/Typography/SGHeadline';
import SGTitle from 'components/Typography/SGTitle';
import SGBody from '../components/Typography/SGBody';
import SGButton from '../components/CTA/SGButton';
import WelcomeImg from '../assets/images/welcome_npos_switch.png';
import {useHistory} from 'react-router-dom';

const StyledHeadline = styled(SGHeadline)`
  font-size: 2rem;
  font-weight: 800;
  text-transform: uppercase;
  word-wrap: break-word;
  margin-bottom: 30px;
`;

const StyledSGBody = styled(SGBody)`
  &.margin-24 {
    margin-bottom: 24px;
  }
  &.margin-32 {
    margin-bottom: 32px;
  }
`;

const StyledButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 16px;
  row-gap: 16px;
  @media (min-width: 600px) {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
  @media (min-width: 960px) {
    grid-template-columns: repeat(3, minmax(120px, 1fr));
  }
`;

const StyledSGButton = styled(SGButton)`
  border-radius: 10px;
  white-space: normal;
`;

const StyledImageContainer = styled.div`
  overflow: hidden;
  background-color: #ffffff11;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
`;

const StyledImage = styled.img`
  width: 100%;
`;

function WelcomePage() {
  let history = useHistory();

  const handleClick = (path: string) => {
    history.push(path);
  };

  return (
    <Layout>
      <Container>
        <Grid container spacing={4} direction="row" alignItems="stretch">
          <Grid item md={12} lg={6}>
            <StyledHeadline variant={'h4'} className={'text-color'}>
              WELCOME TO INSIGHTS
            </StyledHeadline>
            <StyledSGBody variant={'b1'} className={'text-color margin-24'}>
              INSIGHTS currently features the following tools:
            </StyledSGBody>
            <SGTitle variant={'t1'} className={'text-color'}>
              NPOS Registers
            </SGTitle>
            <StyledSGBody variant={'b4'} className={'text-color margin-24'}>
              Nike POS (NPOS) is an advanced replacement for the legacy 1POS fixed point-of-sale
              system. NPOS relies on cloud services and a dedicated iOS app on iPads for registers
              and Customer-Facing Displays (CFDs). The Tech Insights tool provides visibility and
              real-time alerts for troubleshooting NPOS devices. As NPOS continues its global
              rollout, additional capabilities and insights will be introduced to enhance support
              and troubleshooting.
            </StyledSGBody>
            <SGTitle variant={'t1'} className={'text-color'}>
              Switch Connectivity
            </SGTitle>
            <StyledSGBody variant={'b4'} className={'text-color margin-24'}>
              The Switch Connectivity feature provides the status, data, and port configurations of
              switch devices in retail stores, showrooms, and distribution centers.
            </StyledSGBody>
            <SGTitle variant={'t1'} className={'text-color'}>
              Retail Hardware Status
            </SGTitle>
            <StyledSGBody variant={'b4'} className={'text-color margin-32'}>
              Retail Hardware Status provides visibility into the health of retail store devices
              across regions. Monitor device inventory status against ServiceNow, track network
              connectivity, view impacted stores on a map, and export device data to Excel. Drill
              down to individual store device details for troubleshooting and support.
            </StyledSGBody>

            <StyledSGBody variant={'b1'} className={'text-color margin-24'}>
              Click a button below to navigate to the tools or use the left navigation bar:
            </StyledSGBody>
            <StyledButtonContainer>
              <StyledSGButton onClick={() => handleClick('/npos')} size={'large'}>
                NPOS Registers
              </StyledSGButton>
              <StyledSGButton onClick={() => handleClick('/site-search/switch')} size={'large'}>
                Switch Connectivity
              </StyledSGButton>
              <StyledSGButton onClick={() => handleClick('/retail-hardware-status')} size={'large'}>
                Retail Hardware Status
              </StyledSGButton>
            </StyledButtonContainer>
          </Grid>
          <Grid item md={12} lg={6}>
            <StyledImageContainer>
              <StyledImage src={WelcomeImg} alt={'NPOS and Switch Connectivity'} />
            </StyledImageContainer>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
}

export default WelcomePage;
